import { render, staticRenderFns } from "./a-v-datatable-body-row.vue?vue&type=template&id=53f2e4d7"
import script from "./a-v-datatable-body-row.vue?vue&type=script&lang=js"
export * from "./a-v-datatable-body-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports